module.exports = __webpack_public_path__ + "static/img/subcontract13.9659de48.png";